import { DatePipe } from '@angular/common';
import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-edit-data',
  templateUrl: './edit-data.component.html',
  styleUrls: ['./edit-data.component.css'],
  providers: [DatePipe]
})
export class EditDataComponent implements OnInit {

  items:any;
  userform: FormGroup;
  id: null;
  todayDate = new Date();
  maxDate: string;
  maxAvailableDate: Date;

  HE: any = [
    {value: "A"},
    {value: "B"},
    {value: "C"},
    {value: "D"},
    {value: "E"},
    {value: "Aucun"}
  ];

  gender: any = [
    { value: "male" },
    { value: "female"}
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private dialogRef: MatDialogRef<EditDataComponent>,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<Date>,
    private globalSvc: GlobalService,
    ) {
      this.dateAdapter.setLocale('fr');
      this.items = this.data
      if(this.items.id){
        this.id = this.items.id;
      }
    }

  ngOnInit(): void {
    this.globalSvc.fixDisplay();
    //this.items = this.data
    // console.log(this.data)
    this.setMaxAvailableDate();
    this.items = this.data
    this.initForm();
  }

  setMaxAvailableDate(){
    this.maxDate = this.datePipe.transform(this.todayDate, 'MM/dd/yyyy');
    const currentYear = new Date().getFullYear();
    const currentMonth = +this.maxDate.substring(0,2);
    const currentDay = +this.maxDate.substring(3,5);
    this.maxAvailableDate = new Date(currentYear, currentMonth-1 ,currentDay);
  }

  initForm() {

    this.userform = this.fb.group({
      index: new FormControl(this.items.index),
      id: new FormControl(this.id),
      first_name: new FormControl(this.items.first_name, [Validators.required, Validators.maxLength(15)]),
      last_name: new FormControl(this.items.last_name, [Validators.required, Validators.maxLength(30)]),
      email: new FormControl(this.items.email, Validators.required),
      tel: new FormControl(this.items.tel, Validators.required),
      genre: new FormControl(this.items.genre, Validators.required),
      birthday:new FormControl(this.items.birthday, [Validators.required]),
      matrimonial: new FormControl(this.items.matrimonial),
      address:new FormControl(this.items.address,  Validators.maxLength(100)),
      imageUrl: new FormControl(this.items.imageUrl),
      is_selected: new FormControl(this.items.is_selected),
      grab_point: new FormControl(this.items.grab_point),
      country: new FormControl(this.items.country),
      g_sanguin: new FormControl(this.items.g_sanguin),
      tensionCtrl: new FormControl(this.items.tensionCtrl),
      diabeteCtrl: new FormControl(this.items.diabeteCtrl),
      hepatie: new FormControl(this.items.hepatie),
      other_maladie: new FormControl(this.items.other_maladie),
      allergie: new FormControl(this.items.allergie),

    });
  }


  onUpdate(){
      this.dialogRef.close(this.userform.value);
  }

  close() {
      this.dialogRef.close();
  }


}
